export const fontSizes = [
  '8px',
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '22px',
  '24px',
  '28px',
  '30px',
  '32px',
  '34px',
  '36px',
  '38px',
  '40px',
  '48px',
  '52px',
  '54px',
  '96px',
];

export const lineHeights = [
  '10px',
  '16px',
  '18px',
  '22px',
  '24px',
  '26px',
  '28px',
  '30px',
  '32px',
  '36px',
  '38px',
  '40px',
  '42px',
  '46px',
  '58px',
  '64px',
  '85px',
  '104px',
];
